import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png",
      alt: "Estratégias AlgoTrading",
    },
    title: "Adicione inteligência aos seus trades",

    // String ou array de strings
    text: "Estratégias desenvolvidas 100% por um software de Inteligência Artificial, que monta os modelos, e faz ajustes em tempo real nas estratégias, sempre buscando a melhor adaptação à volatilidade atual do mercado.",
    testimonial: {
      text: "Nossas estratégias contam com o que existe de melhor no mundo da Inteligência Artificial, e evoluem constantemente, sem nenhuma intervenção humana. É a realidade do Trade Inteligente chegando ao mercado.",
      author: {
        name: "Fabiano Oliveira, CEO AlgoTrading Algoritmos",
        picture: "",
      },
    },
  },
  stats: {
    title: "Números ao longo desses 7 anos de experiência",
    subtitle:
      "A AlgoTrading é uma das empresas pioneiras no desenvolvimento de algotirmos para negociações automatizadas.",
    data: [
      {
        value: "+30k",
        description: "Clientes",
      },
      {
        value: "+10M",
        description: "Contratos negociados",
      },
      {
        value: "+155Bi",
        description: "Volume financeiro",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da AlgoTrading?",
    subtitle: "Veja quais as principais vantagens dos robôs da AlgoTrading.",
    data: [
      {
        icon: iconsSet.growth,
        title: "Performance no DNA",
        description:
          "Nossos robôs são desenvolvidos por um software que utiliza um Algoritmo Genético que está entre os mais modernos do mundo para o segmento, encontrando padrões e montando estratégias de altíssima performance, sem intervenção humana.",
      },
      {
        icon: iconsSet.signal,
        title: "Controle de risco em tempo real",
        description:
          "O controle de risco é feito em tempo real pelo próprio robô, analisando o movimentação do ativo e do mercado, ajustando os alvos e buscando somente as melhores operações.",
      },
      {
        icon: iconsSet.code,
        title: "Inteligência artificial",
        description:
          "O mercado mudou? Não se preocupe, os robôs da AlgoTrading contam com um software de Inteligência Artificial, que ajusta constantemente as estratégias à realidade do mercado, buscando sempre a melhor adaptação.",
      },
      ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a AlgoTrading IA.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A AlgoTrading",
    col1: [
      'Somos Traders! E isso faz toda a diferença. Nosso trabalho com algoritmos vem desde 2012, quando, sem ferramentas adequadas no mercado brasileiro, começamos a desenhar estratégias e monitorar o mercado através de planilhas em Excel. É evidente que as estratégias eram simples, e os problemas, enormes. Só podíamos trabalhar com tempos gráficos maiores, pois não tínhamos os dados em tempo real. Os indicadores tinham que ser todos construídos "na mão". Acabamos entrando no mundo da programação por necessidade, pois precisávamos construir macros no Excel que gravassem os dados do mercado via link DDE (recurso que importa para o Excel cotações em tempo real), e, com isso, operar tempos gráficos menores. Posteriormente, encontramos um sistema que permitia o envio de ordens diretamente pelo Excel, o que, para nós, já era uma grande evolução. Além disso, passamos a ter também o histórico que tanto precisávamos, mesmo que cheio de falhas. Esse sistema, apesar dos erros recorrentes (que nos levaram, futuramente, a abandoná-lo) permitiu que montássemos nosso primeiro robô 100% automatizado, com o qual tivemos excelentes resultados. As já citadas falhas,porém, nos levaram a decisão de desligar o sistema. Naquele momento, final de 2013, as perspectivas eram as piores possíveis para o mercado de robôs investidores.',
      "No início de 2014, porém, tudo mudou. Ficamos sabendo que a XP Investimentos traria para o Brasil o MetaTrader 5, o sistema mais utilizado no mundo para automatização no mercado financeiro. Iniciamos imediatamente os estudos, e, em maio, no mesmo mês em que o sistema foi lançado, já tínhamos robôs operando no sistema.",
    ],
    col2: [
      'Com o conhecimento e a experiência que já tínhamos, evoluímos rapidamente, o que acabou levando a um convite por parte da XP para que o sócio fundador da AlgoTrading, Fabiano Oliveira, assumisse o projeto MetaTrader no Brasil. Durante esse período, merecem destaque a criação e desenvolvimento da comunidade MetaTrader 5 - Experiências, que hoje conta com milhares de usuários e desenvolvedores, e a produção da "Boleta Turbo", que passou a ser distribuída com o próprio MetaTrader da XP, e é o robô mais utilizado do Brasil, sendo utilizado por centenas de pessoas, e negociando milhares de contratos por dia.',
      'Em Julho de 2015, Fabiano Oliveira retornou a AlgoTrading, onde continuou a parceria com a XP Investimentos, buscando o desenvolvimento do mercado de algoritmos no Brasil. Os robôs AlgoTrading se tornaram, então, sinônimo de estabilidade e qualidade, sendo utilizados por milhares de usuários. Nosso sistema de conexão remota revolucionou o mercado, permitindo um ganho de escala nunca visto nessa área, e se tornando a base da grande campanha que lançamos por robôs "a preço justo", em dezembro/2015. Somos a maior plataforma de robôs do país, e acreditamos que a automatização é a maior revolução no mercado financeiro desde o Home Broker. A AlgoTrading tem orgulho de sua história se confundir com a própria história da automatização no mercado de varejo do Brasil. Temos a certeza de que, mais do que apenas percebendo, estamos PROMOVENDO esta mudança.',
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão AlgoTrading IA",
  },
  strategies: {
    title: "AlgoTrading IA",
    heading: "Tenha acesso às melhores estratégias de day trade",
    subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
